import { render } from "./InspecaoValoresCadastro.vue?vue&type=template&id=291aa344&ts=true"
import script from "./InspecaoValoresCadastro.vue?vue&type=script&lang=ts"
export * from "./InspecaoValoresCadastro.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\RopeSeguros\\FrontEnd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__